import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';

@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.css']
})
export class VideoPlayerComponent implements OnInit {

  @ViewChild('video') video: ElementRef;
  @Input() src: string;
  @Input() fullscreen = true;
  @Output('videoEnded') ended = new EventEmitter();
  @Output('videoStarted') started = new EventEmitter();


  showPlayControls = false;

  constructor() {
  }

  pause(): void {
    console.log('pause');
    this.video.nativeElement.pause();
  }

  resume(): void {
    this.video.nativeElement.play();
  }

  playing(): boolean {
    return !!(this.video?.nativeElement.currentTime > 0 && !this.video?.nativeElement.paused && !this.video?.nativeElement.ended && this.video?.nativeElement.readyState > 2);

  }

  playVideo(): void {
    console.log('Play video');
    try {
      this.video.nativeElement.load();

    } catch (e) {
      console.log(e);
    }

    try {
      const promise = this.video.nativeElement.play();
      console.log(promise);
      if (promise != null) {
        promise.then(value => {
          console.log(value);
          if (value.status === 'rejected') {
            this.showPlayControls = true;
          }
        });

      }
    } catch (error) {
      console.log(error);
    }

    if (!this.fullscreen) {
      return;
    }

    try {
      this.video.nativeElement.webkitEnterFullscreen();
    } catch (e) {
      console.log(e);
    }

    try {
      this.video.nativeElement.requestFullscreen();
    } catch (e) {
      console.log(e);
    }
  }

  startedPlaying(): void {
    this.started.emit(true);
  }

  videoEnded(): void {
    try {
      this.video.nativeElement.webkitExitFullScreen();
    } catch (e) {
      console.log(e);
    }

    try {
      document.exitFullscreen();
    } catch (e) {
      console.log(e);
    }

    // if (document.exitFullscreen) {
    //   document.exitFullscreen();
    // } else if (document.mozCancelFullScreen) { /* Firefox */
    //   document.mozCancelFullScreen();
    // } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
    //   document.webkitExitFullscreen();
    // } else if (document.msExitFullscreen) { /* IE/Edge */
    //   document.msExitFullscreen();
    // }


    this.ended.emit(true);
  }

  ngOnInit(): void {
  }

}
